import React, { ChangeEventHandler, FormEventHandler } from 'react';

import { Button, GridLegacy as Grid, TextField } from '@mui/material';

type Props = {
  id: string;
  searchString: string;
  handleChange: ChangeEventHandler<HTMLInputElement>;
  handleSubmit: FormEventHandler<HTMLFormElement>;
  type?: string;
  name?: string;
  label?: string;
  placeholder?: string;
  showSubmitButton?: boolean;
};

export default function SearchForm({
  id,
  searchString,
  handleChange,
  handleSubmit,
  type = 'text',
  name = 'searchString',
  label = '',
  placeholder = 'Search here',
  showSubmitButton = true,
}: Props) {
  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={showSubmitButton ? 8 : 12}>
          <TextField
            id={id}
            type={type}
            name={name}
            label={label}
            placeholder={placeholder}
            value={searchString}
            onChange={handleChange}
            autoFocus
            fullWidth
          />
        </Grid>
        {showSubmitButton && (
          <Grid item xs={4}>
            <Button type="submit" variant="contained" className="T-search-user">
              Search
            </Button>
          </Grid>
        )}
      </Grid>
    </form>
  );
}
